<template>
    <div>
        <div class="white-container">
            <div class="mid-container">
                <div class="side-wrapper" style="display: flex;align-items: center;justify-content: center;">
                    <div class="middle-wrapper">
                        <div class="lead-avatar">
                            <div class="user-avatar-container">
                                <div class="avatar-container">
                                    <div class="avatar">
                                        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0)">
                                        <path d="M32 31.3002C39.1157 31.3002 44.8846 24.2935 44.8846 15.6502C44.8846 7.00672 42.9906 0 32 0C21.0093 0 19.1149 7.00672 19.1149 15.6502C19.1149 24.2935 24.8839 31.3002 32 31.3002Z" fill="#C2C3CA"/>
                                        <path d="M7.66318 55.1966C7.66109 54.6696 7.659 55.0481 7.66318 55.1966V55.1966Z" fill="#C2C3CA"/>
                                        <path d="M56.3354 55.6076C56.3421 55.4633 56.3377 54.6066 56.3354 55.6076V55.6076Z" fill="#C2C3CA"/>
                                        <path d="M56.308 54.5649C56.0693 39.5081 54.1029 35.2177 39.055 32.502C39.055 32.502 36.9368 35.2011 31.9997 35.2011C27.0625 35.2011 24.9439 32.502 24.9439 32.502C10.0603 35.1881 7.97425 39.4149 7.69996 54.0758C7.67747 55.273 7.66705 55.3359 7.66302 55.1969C7.66394 55.4573 7.66504 55.9389 7.66504 56.7788C7.66504 56.7788 11.2476 64.0009 31.9997 64.0009C52.7514 64.0009 56.3343 56.7788 56.3343 56.7788C56.3343 56.2392 56.3347 55.864 56.3352 55.6087C56.3312 55.6946 56.3231 55.5281 56.308 54.5649Z" fill="#C2C3CA"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0">
                                        <rect width="64" height="64" fill="white"/>
                                        </clipPath>
                                        </defs>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div class="user-name" style="margin-top:30px;">{{profile.first_name}} {{profile.last_name}}</div>
                        </div>
                    </div>
                </div>
                <div class="mid-wrapper">
                    <table class="info" style="margin: 0px auto;">
                        <tr>
                            <td>{{$t('profile.LBL_PHONE')}}</td>
                            <td><span v-html="profile.phone"></span></td>
                        </tr>
                        <tr>
                            <td>{{$t('profile.LBL_SKYPE')}}</td>
                            <td><span v-html="profile.skype"></span></td>
                        </tr>
                        <tr>
                            <td>{{$t('profile.LBL_DOB')}}</td>
                            <td><span v-html="profile.dob"></span></td>
                        </tr>
                        <tr>
                            <td>{{$t('profile.LBL_EMAIL')}}</td>
                            <td><span v-html="profile.email"></span></td>
                        </tr>
                        <tr>
                            <td>{{$t('profile.LBL_PASSWORD')}}</td>
                            <td><a :href="url_prefix+'/profile/edit'">{{$t('profile.LBL_CHANGE_PASSWORD')}}</a></td>
                        </tr>
                        <tr>
                            <td>{{$t('profile.LBL_GENDER')}}</td>
                            <td><span v-html="profile.gender?$t('lists.genders_list.'+profile.gender):$t('lists.genders_list.null')"></span></td>
                        </tr>
                    </table>
                    <div class="middle-wrapper" style="margin-top:30px">
                        <a :href="url_prefix+'/profile/edit'" class="button">
                            <span>{{$t('strings.BTN_EDIT')}}</span>
                        </a>
                    </div>
                </div>
                <div class="side-wrapper"></div>
            </div>
        </div>
        <div class="white-container">
            <div class="middle-wrapper">
                <h2>{{$t('profile.LBL_ATTACH_SOCIAL_NETWORKS_TITLE')}}</h2>
            </div>
            <div class="mid-wrapper">
                <table class="info" style="margin: 0px auto;margin-top:40px;">
                    <tr>
                        <td>
                            <div class="social-icon icon-google">
                                <div class="icon"  style="float:left">
                                    <img src="../../../assets/img/google.svg">
                                </div>
                                <span>Google</span>
                            </div>
                        </td>
                        <td>
                            <span v-if="profile.google">{{$t("profile.LBL_NETWORK_CONNECTED")}}</span>
                            <span v-else>
                                <a :href="getGoogleUrl">{{$t("profile.LBL_CONNECT_NETWORK")}}</a>
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="social-icon icon-fb">
                                <div class="icon" style="float:left">
                                    <img src="../../../assets/img/fb.svg" alt="fb">
                                </div>
                                <span>Facebook</span>
                            </div>
                        </td>
                        <td>
                            <span v-if="profile.facebook">{{$t("profile.LBL_NETWORK_CONNECTED")}}</span>
                            <span v-else>
                                <a :href="getFacebookUrl">{{$t("profile.LBL_CONNECT_NETWORK")}}</a>
                            </span>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <ErrorPopup 
            :show="display_error" 
            :popup_header="error.title" 
            :popup_description="error.description" 
            v-on:closeEvent="display_error=false"
            :buttons="error.buttons"
        />
    </div>
</template>
<style lang="scss">
    .lead-avatar{
        .user-avatar-container{
            position:relative;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            width: 100%;
            .avatar-container{
                position:relative;
                width:100%;
                max-width:140px;
                border-radius: 100%;
                background: #F9F9F9;
                &::before{
                    position: relative;
                    content:"";
                    display:block;
                    padding-top:100%;
                }
                .avatar{
                    position: absolute;
                    top:0px;
                    right:0px;
                    bottom:0px;
                    left:0px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    &>svg{
                        height: 64px;
                    }
                }
            }
        }
        .user-name{
            font-family: FuturaPT;
            letter-spacing: 0.05rem;
            font-size: 1.6rem;
            line-height: 2rem;
            color:#0B1022;
        }
    }
    .social-icon{
        display:flex;
        align-items: center;
        justify-content: flex-start;
        &.icon-fb{
            svg{

            }
        }
        &.icon-google{
            svg{
                
            }
        }
        &>.icon{
            margin-right:15px;
        }
        &>span{
            font-family: FuturaPT;
            letter-spacing: 0.05rem;
            font-size: 1.6rem;
            line-height: 2rem;
            color:#0B1022;
        }
    }
</style>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import store from '@/store';
    import {rest} from '@/utils/utils';
    import i18n from '@/i18n';
    import lStorage from '@/store/localStorage';
    import env from '@/enviroment';
    import ErrorPopup from "@/views/pages/manager_popups/ErrorPopup";

    export default {
        name:'ProfileEdit',
        components:{
            ErrorPopup
        },
        data:function(){
            return{
                display_error:false,
                error:{
                    title:"",
                    description:"",
                    buttons:[]
                },
                profile:{
                    first_name:"",
                    last_name:"",
                    phone:"",
                    email:"",
                    dob:"",
                    audio:true,
                    skype:"",
                    language:"ro",
                    gender:"",
                }
            }
        },
        mounted(){
            //Загрузим информацию о пользователе
            store.commit('loading/is', true);
            this.isLoad = false;
            //Получим товары из предложения
            rest.call("get_profile",{},"GET").then((response)=>{
                this.isLoad = true;
                store.commit('loading/is', false);
                if(response.status && response.status == "ok" && response.data){
                    this.profile = response.data;
                }
            }).catch((error)=>{
                this.isLoad = true;
                store.commit('loading/is', false);
            });
            if(this.$route.query && this.$route.query.error){
                switch(this.$route.query.error.toString()){
                    case "918":
                        this.display_error = true;
                        this.error = {
                            title:i18n.t('profile.LBL_COULDNT_CONNECT_NETWORK'),
                            description:i18n.t('soap.918'),
                            buttons:[]
                        };
                    break;
                }
            }
        },
        methods:{
            
        },
        computed:{
            ...mapGetters({
                user: 'user/get',
            }),
            url_prefix(){
                return (i18n.locale=="ro"?"":"/"+i18n.locale);
            },
            getGoogleUrl(){
                return env.URL+'/custom/service/v4_2/rest.php?method=link_profile&input_type=JSON&response_type=JSON&rest_data='+JSON.stringify({"session":lStorage.get('auth-token'),network:"google"});
            },
            getFacebookUrl(){
                return env.URL+'/custom/service/v4_2/rest.php?method=link_profile&input_type=JSON&response_type=JSON&rest_data='+JSON.stringify({"session":lStorage.get('auth-token'),network:"facebook"});
            }
        },
    }
</script>